import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    Grid,
    Typography
} from '@material-ui/core';
import Lottie from 'react-lottie';
import axios from '../../config/axiosInstance';
import animationData from './Animations/Coupon.json';
import { usageLog } from '../../store/actions/globalActions';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
    paper: {
        minWidth: "995px",
        paddingTop: "60px",
        paddingBottom: "60px"
    }
});

const CouponModal = ({ classes }) => {


    useEffect(() => {
        searchCoupon();
        // if (localStorage.statusPayment == 'true') {
        // }
    }, [])

    const [modalCupom, setModalCupom] = useState(false);
    const [cupom, setCupom] = useState({});
    const [seconds, setSeconds] = useState(3);
    const [animationState, setAnimationState] = useState({ isStopped: false, isPaused: false });

    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };

    function searchCoupon() {
        // axios.get('/warning')
        //     .then((result) => {
        //         if (!result.data.openModalBlocked && !result.data.openModalWarning) {
        //             if (result.data?.hasTicket?.hasTicketAvaliable) {
        //                 setModalCupom(result.data?.hasTicket ? true : false)
        //                 setCupom(result?.data?.hasTicket)
        //             } else { }
        //         }
        //     })
        //     .catch(error => console.log('error', error));
    };

    const formatter = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
    });

    setTimeout(cronometro, 1000)
    function cronometro() {
        if (seconds > 0) {
            setSeconds(seconds - 1)
        }
    };

    function redirectTopayment() {
        const companyId = JSON.parse(localStorage.getItem('companies')).find(x => x.companyId).companyId;
        const userId = JSON.parse(localStorage.getItem('companies')).find(x => x.userId).userId;
        const values = cupom;
        usageLog(`Dashboard/modal/cupom/anoNovo/${cupom.ticketName}/assinar`, companyId, userId, values);
    };

    function closeModalCupom() {
        setModalCupom(false);
        const companyId = JSON.parse(localStorage.getItem('companies')).find(x => x.companyId).companyId;
        const userId = JSON.parse(localStorage.getItem('companies')).find(x => x.userId).userId;
        const values = cupom;
        usageLog(`Dashboard/modal/cupom/anoNovo/${cupom.ticketName}/fechou`, companyId, userId, values);
    };

    return (
        <Dialog
            open={modalCupom}
            onClose={() => closeModalCupom()}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            // maxWidth='lg'
            classes={{ paper: classes.paper }}
        >
            <Grid
                style={{
                    width: '100px',
                    height: '100px',
                    borderRadius: '50px',
                    alignSelf: 'center',
                    border: '2px solid #537ccd9c',
                    marginTop: '10px',
                    marginBottom: '-30px'
                }}
            >
                <Lottie
                    options={defaultOptions}
                    width={100}
                    height={100}
                    isStopped={animationState.isStopped}
                    isPaused={animationState.isPaused}
                />
            </Grid>

            <DialogTitle id="alert-dialog-title">
            </DialogTitle>
            <DialogTitle id="alert-dialog-title">
                <Typography style={{ color: '#3978D3', fontWeight: 'bold', fontSize: '40px', textAlign: 'center' }} >Mês do Consumidor</Typography>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description" style={{ textAlign: 'center' }}>
                        <Typography style={{ textAlign: 'center', fontSize: '20px' }}>Aproveite o Mês do Consumidor para dar um upgrade na sua gestão de ponto!<br /> Temos uma super oferta para você!</Typography>
                        {/* <Typography style={{ textAlign: 'center', fontSize: '20px' }}>Para te ajudar nisso, temos uma oferta incrível para você:</Typography> */}
                        {cupom.value == 59 ?
                            <Typography style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '27px', fontWeight: 'bold', margin: "28px" }}>Seja Premium com Desconto.<br /> De R$89/mês por apenas R${cupom.value}/mês!</Typography>
                            :
                            <Typography style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '27px', fontWeight: 'bold', margin: "28px" }}>Seja Premium com Desconto.<br /> De R$89/mês por apenas R${cupom.value}/mês!</Typography>
                        }
                        {cupom.value == 59 ?
                            <Typography style={{ textAlign: 'center', fontSize: '20px' }}>Basta clicar no botão abaixo e usar o cupom {cupom.ticketName} no momento da assinatura.</Typography>
                            :
                            <Typography style={{ textAlign: 'center', fontSize: '20px' }}>Basta clicar no botão abaixo e usar o cupom {cupom.ticketName} no momento da assinatura.</Typography>
                        }
                        {/* <Typography style={{ textAlign: 'center', fontSize: '20px' }}>para aproveitar essa oportunidade exclusiva.</Typography> */}
                    </DialogContentText>
                </DialogContent>
                <Grid style={{ textAlign: 'center' }}>
                    <Button
                        component={Link} to={`/assinatura?plan=Premium&Pagamento=false&Cupom=${cupom.ticketName ? cupom.ticketName : ''}`}
                        onClick={redirectTopayment}
                        style={{
                            backgroundColor: '#537ccd',
                            fontSize: " 38px",
                            fontWeight: "bold",
                            color: "white",
                            borderRadius: "51px",
                            paddingLeft: "50px",
                            paddingRight: "50px"
                        }}
                    >
                        QUERO SER PREMIUM
                    </Button>
                </Grid>
            </DialogTitle>

            <Grid style={{ textAlign: 'center' }}>
                {cupom.value == 59 ?
                    <Typography style={{ textAlign: 'center', fontSize: '15px' }}>Não perca essa oportunidade de turbinar sua gestão de ponto.<br />
                        Oferta válida até <strong>31 de março</strong>.</Typography>
                    :
                    <Typography style={{ textAlign: 'center', fontSize: '15px' }}>Não perca essa oportunidade de turbinar sua gestão de ponto com quase 80% de desconto.<br />
                        Oferta válida até <a style={{ fontWeight: 'bold' }}>31 de março</a> e para empresa com menos de 10 funcionários.</Typography>
                }
                <Typography style={{ textAlign: 'center', fontSize: '15px' }}>Clique agora no botão acima e turbine sua gestão de ponto!.<br/></Typography>
                <Button
                    variant='contained'
                    style={{transform: "translateX(400%)"}}
                    onClick={() => closeModalCupom()}
                >
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;SAIR&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </Button>
            </Grid>
        </Dialog >
    );
};

export default (withStyles(styles)(CouponModal));

{/* <Dialog
            open={modalCupom}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <Grid
                style={{
                    width: '100px',
                    height: '100px',
                    borderRadius: '50px',
                    alignSelf: 'center',
                    border: '2px solid #537ccd9c',
                    marginTop: '10px',
                    marginBottom: '-30px'
                }}
            >
                <Lottie
                    options={defaultOptions}
                    width={100}
                    height={100}
                    isStopped={animationState.isStopped}
                    isPaused={animationState.isPaused}
                />
            </Grid>

            <DialogTitle id="alert-dialog-title">
            </DialogTitle>
            <DialogTitle id="alert-dialog-title">
                <Typography style={{ color: '#3978D3', fontWeight: 'bold', fontSize: '40px', textAlign: 'center' }} >PARABÉNS!</Typography>
                <Grid style={{ backgroundColor: '#537ccd', borderRadius: '10px', padding: '20px' }}>
                    <Typography style={{ color: '#FFFF', textAlign: 'center', fontWeight: 'lighter', fontSize: '30px' }} >VOCÊ GANHOU</Typography>
                    <Typography style={{ color: '#FFFF', textAlign: 'center' }} >UM CUPOM DE DESCONTO</Typography>
                </Grid>
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    Use o cupom '{cupom?.ticketName}' e pague apenas R$ {cupom?.value} na mensalidade.
                </DialogContentText>
            </DialogContent>
            {seconds == 0 ?
                (
                    <DialogActions>
                        <Button onClick={closeModalCupom}>FECHAR</Button>
                        <Button variant='contained' color="primary" component={Link} to="/assinatura?plan=Premium&Pagamento=false" onClick={redirectTopayment}>Assinar</Button>
                    </DialogActions>
                ) : <Typography style={{ color: '#3978D3', textAlign: 'center', margin: '5px', fontSize: '25px' }}>{seconds}</Typography>
            }
        </Dialog > */}